import { Bundle } from 'generated/mos/org/getty/publish'

const BUNDLE_TITLES = {
  BUNDLE_TYPE_PRIVATE: 'Private',
  BUNDLE_TYPE_PUBLIC: 'Public',
  BUNDLE_TYPE_UNSPECIFIED: ''
}
export const bundleProcessingFailed = ({processingStatus}: Bundle.Entity): boolean => {
  return processingStatus === 'BUNDLE_PROCESSING_FAILED';
}
export const bundleProcessingRunning = ({processingStatus}: Bundle.Entity): boolean => {
  return processingStatus === 'BUNDLE_PROCESSING_RUNNING';
}
export const bundleName = ({bundleType}: Bundle.Entity): string => {
  return BUNDLE_TITLES[bundleType];
}
export const errorMessage = (bundle: Bundle.Entity): string => {
  return `Publishing of ${bundleName(bundle)} bundle failed.`
}
export const runningMessage = (bundle: Bundle.Entity): string => {
  return `Publishing of ${bundleName(bundle)} bundle is currently in progress.`
}
